import { useEffect, useState, type ReactNode } from "react";
import { LogIn, RefreshCw, ShieldCheck } from "lucide-react";
import { verifyDiscordAccess, type AccessSession } from "./service";

export function DiscordAccessGate({ children }: { children: ReactNode }) {
  const [session, setSession] = useState<AccessSession | null>(null);
  const check = () => {
    setSession(null);
    void verifyDiscordAccess().then(setSession);
  };
  useEffect(check, []);
  if (!session) return <div className="access-gate"><div className="access-card"><RefreshCw className="spin" /><p className="eyebrow">狩猎许可 · 社区验证</p><h1>怪物猎人</h1><strong className="access-subtitle">狩猎人生</strong><p>正在通过 Discord 确认社区成员身份……</p></div></div>;
  if (session.authenticated && session.accessStatus === "allowed") return <>{children}</>;
  const membership = session.accessStatus === "membership_required" || new URLSearchParams(location.search).get("auth") === "membership_required";
  const reauth = session.accessStatus === "reauthentication_required";
  const backendUnavailable = session.accessStatus === "backend_unavailable";
  const local = location.hostname === "localhost" || location.hostname === "127.0.0.1";
  return <div className="access-gate"><div className="access-card">
    <ShieldCheck size={42} />
    <p className="eyebrow">狩猎许可 · 社区验证</p>
    <h1>怪物猎人</h1><strong className="access-subtitle">狩猎人生</strong>
    <h2>{backendUnavailable ? (local ? "本地验证服务未启动" : "验证服务暂时不可用") : membership ? "尚未取得社区通行资格" : reauth ? "Discord 登录已失效" : "需要 Discord 身份验证"}</h2>
    <p>{backendUnavailable ? (local ? "页面已启动，但本地 Pages Functions 没有就绪。请确认 npm run dev:full 已显示 5173 与 8788 均已就绪，然后重新检查。" : "身份验证后端暂时无法响应，请稍后重新检查；当前不会跳转到失效的登录页面。") : membership ? "请先加入获准的 Hajimi Productions 社区服务器，再回来重新核验。" : reauth ? "请重新登录 Discord，以便再次确认服务器成员身份。" : "每次打开怪物猎人都会实时核验服务器成员身份；Discord 暂时不可用时，最近一次成功核验可提供最多 24 小时宽限。"}</p>
    <div className="button-row">{!backendUnavailable && <a className="button-link primary" href="/api/auth/discord/login"><LogIn size={17} />使用 Discord 验证</a>}<button onClick={check}><RefreshCw size={17} />重新检查</button></div>
  </div></div>;
}
